import React, { Fragment } from "react";
import { PropTypes } from "prop-types";
import HtmlTooltip from "./HtmlTooltip";

export default function CompanyAddress({ type }) {
  return (
    <HtmlTooltip
      type={type}
      title={
        <Fragment>
          <p>
            <b>Company Address</b>
          </p>
          <p>
            Company addresses are structured as:
            <pre>
              <code>
                {`
{
  “line1”: string: Address Line 1,
  “line2”: string: Address Line 2,
  “line3”: string: Address Line 3,
  “line4”: string: Address Line 4,
  “line5”: string: Address Line 5,
  “city”: string,
  “stateProvince”: string,
  “postalCode”: string,
  “country”: string
`}
              </code>
            </pre>
          </p>
        </Fragment>
      }
    ></HtmlTooltip>
  );
}
CompanyAddress.propTypes = {
  type: PropTypes.string.isRequired
};
